document.addEventListener("alpine:init", () => {
    Alpine.data("contactForm", () => ({
        selectfields: null,
        sendingContainer: null,
        success: false,
        form: null,
        confirmationPage: null,
        downloadLink: null,
        init() {
            this.form = this.$el.querySelector("form.wpcf7-form");
            this.sendingContainer = this.$el.querySelector(".form__sending");

            this.$el.querySelectorAll(".wpcf7-submit").forEach((button) => {
                button.addEventListener("click", () => {
                    this.sendingContainer.classList.remove("hidden");
                    this.sendingContainer.classList.add("flex");
                });
            });

            this.$el.querySelector(".wpcf7").addEventListener(
                "wpcf7invalid",
                (e) => {
                    this.sendingContainer.classList.add("hidden");
                    this.sendingContainer.classList.remove("flex");
                },
                false
            );

            this.confirmationPage = this.$el.dataset.confirmationPage;
            this.form.addEventListener("wpcf7mailsent", (event) => {
                this.fetchConfirmation();
            });

            this.downloadLink = this.$el.dataset.downloadLink;

            this.selectfields = this.$el.querySelectorAll("select");
            pegasus.selectField(this.selectfields, {
                openOnHover: false,
                itemsToShow: 5,
                firstItemDisabled: true,
                classNames: {
                    outerWrapper: "",
                    selector:
                        "Form__Selector -no-cancel w-full cursor-pointer flex text-left relative focus:outline-none py-2 pr-1",
                    selectorOpen: "-open",
                    selectionList:
                        "Form__Selector-list w-full rounded-b-md -open",
                    listItem:
                        "select-none relative transition duration-300 py-4 px-6",
                    listItemFocus: "bg-secondary-pink",
                },
            });
        },

        fetchConfirmation() {
            const mainContainer = this.$el.querySelector(".main-container");
            fetch(this.confirmationPage)
                .then((response) => response.text())
                .then((html) => {
                    const parser = new DOMParser(),
                        doc = parser.parseFromString(html, "text/html");

                    const replace = doc.querySelector("article");
                    mainContainer.innerHTML = replace.innerHTML;
                    this.success = true;

                    if (this.downloadLink) {
                        window.open(this.downloadLink);
                    }
                });
        },
    }));
});
